<template>
  <v-menu
    :close-on-content-click="true"
    max-height="400"
    min-width="200"
    nudge-left="20"
    transition="slide-y-transition"
    bottom
    offset-y>
    <template
      #activator="{ on }">
      <v-icon
        :color="activeTagsList.length ? 'blue' : 'darkGrey'"
        class="pointer"
        size="18"
        v-on="on">
        mdi-filter
      </v-icon>
    </template>
    <v-card class="pa-0">
      <v-list class="pa-0">
        <v-list-item
          v-for="(tag, index) in tagsList"
          :key="index"
          :class="{ 'v-list-item--active': activeTagsList.includes(tag) }"
          @click="updateActiveTags(tag)">
          <v-list-item-title>{{ tag }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-card-actions v-if="activeTagsList.length !== 0">
        <v-btn
          color="blue"
          block
          outlined
          @click="clearFilter">
          Clear filter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import {
  mapState, mapMutations, mapActions, mapGetters,
} from 'vuex';

import { RECALCULATE_TAG_TOTAL_COST } from '@/constants/userPermissions';

export default {
  name: 'FilterMenu',
  props: {
    col: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState('ProjectDetailsTableSchedule', ['scheduleId']),
    ...mapState('ScheduleViews', ['activeTags']),
    ...mapGetters('ScheduleRows', ['scheduleTagsList']),
    tagsList() {
      return this.scheduleTagsList(this.col);
    },
    activeTagsList() {
      return this.activeTags && this.activeTags[this.col] ? this.activeTags[this.col] : [];
    },
  },
  methods: {
    ...mapMutations({
      setTagTotal: 'ProjectAggregation/setTagTotal',
      setActiveTags: 'ScheduleViews/setActiveTags',
    }),
    ...mapActions({
      getTotalOfTag: 'ProjectAggregation/getTotalOfTag',
      removeSubscriptions: 'ManageSubscriptions/removeSubscriptions',
    }),
    async updateActiveTags(tag) {
      let activeTags = this.activeTags[this.col] || [];
      if (activeTags.includes(tag)) {
        activeTags = activeTags.filter(t => t != tag);
        this.setActiveTags({
          ...this.activeTags,
          [this.col]: activeTags.length ? activeTags : undefined,
        });
      } else {
        this.setActiveTags({
          ...this.activeTags,
          [this.col]: [...activeTags, tag],
        });
      }
      this.totalCostOfTag(tag);
    },
    async totalCostOfTag(tagName) {
      try {
        await this.getTotalOfTag({
          tableId: this.scheduleId,
          tableType: 'schedule',
          tagName,
        });
      } catch (err) {
        console.log(err);
      }
    },
    clearFilter() {
      this.setActiveTags({
      });
      this.setTagTotal(null);
      this.removeSubscriptions(RECALCULATE_TAG_TOTAL_COST);
    },
  },
};
</script>
